import axios from '@/api/axiosInstance';

export default async function getTaskTemplate(id) {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_API}/taskTemplates/${id}`
  );
  return response.data;
}
